import React from 'react'
import { hooks } from '@front/volcanion'
import { GeoUtils, OrderUtils } from '@front/volcanion/utils'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

import FormatUtils from '@front/squirtle/utils/format'

const Row = ({ row }) => {
  const isB2B = !!row?.service
  const orderStatus = OrderUtils.getOrderStatus(row?.status, row?.confirmed)
  const [{ name }] = hooks.useCustomerInfo(row?.do?.user_id)
  return (
    <>
      <TableCell size='small'><TextCell value={FormatUtils.formatDateBackToFront(row?.requestedAt)} /></TableCell>
      <TableCell size='small'><TextCell value={row?.order_client_id} /></TableCell>
      <TableCell size='small'><TextCell value={row?.commercial_package?.name_translated} /></TableCell>
      <TableCell size='small'>
        <TextCell value={GeoUtils.format(row?.source)} />
        <TextCell value={GeoUtils.format(row?.destination)} />
      </TableCell>
      <TableCell size='small'>
        <TextCell value={!!isB2B ? row?.service?.contract?.company?.name : name} />
      </TableCell>
      <TableCell size='small'>
        <TextCell value={orderStatus} color={hooks.useOrderStatusColor(row)} />
      </TableCell>
    </>
  )
}

export default React.memo(Row)
